import { render, staticRenderFns } from "./ServicePage.vue?vue&type=template&id=42c7949f"
import script from "./ServicePage.vue?vue&type=script&lang=js"
export * from "./ServicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports